import secureLocalStorage from "react-secure-storage";
import * as React from "react";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import moment from "moment";

export default class TaskActualCompDate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        temp: this.props.dataItem[this.props.field],        
    };
  }
  componentDidMount = () => {
    
    try {
      let element = document.getElementsByClassName("k-dateinput")[0];
      if (element) {
        element.addEventListener("keydown", (e) => {
          e.stopPropagation();
          e.preventDefault();
        });
      }
    } catch (err) {
      console.error(err);
    }
  };
  handleChange = (e) => {    
    this.props.onChange({
        dataItem: this.props.dataItem,
        field: this.props.field,
        syntheticEvent: e.syntheticEvent,
        value: e.value,
      });
      if (
        this.props.field &&
        this.props.field === this.props.dataItem.inEdit 
      ) {
        let updateData = {
          ...this.props.dataItem,
          [this.props.field]: e.value,
        };
        this.props.updateDropdownValue(updateData);
      }
  };
    
  handleEditCell = () => {
    if(( this.props.dataItem.isClosed===false || this.props.dataItem.isClosed==="Open" ) && (!this.props.isTask)){

    this.props.onEditCell(this.props.dataItem, this.props.field);
    }
  };
  render() {
    const { dataItem, field } = this.props;
    const loginUserId=parseInt(secureLocalStorage.getItem("loginUserId"));
    const ownerId=dataItem.ownerId;
    const dataValue = dataItem[field] === null || dataItem[field] == undefined ? "" : new Date(dataItem[field]);

    
    if (this.props.field && this.props.field === this.props.dataItem.inEdit) {
      return (
        <td>
           <DatePicker
            format="dd-MMM-yyyy"
            defaultValue={dataValue}
            onChange={this.handleChange.bind(this)}
            defaultShow={true}
            max={new Date()}
          />
        </td>
      );
    } else {       
      if((loginUserId===ownerId)&&this.props.dataItem.isClosed===false){
        return (
          <td onClick={this.handleEditCell}>
            {dataValue?moment(dataValue).format('DD-MMM-YYYY'):''}
          </td>
        )
      }else{ 
      return this.props.dataItem.roleName == "View Only"||this.props.dataItem.roleName == "Standard User"||this.props.dataItem.isClosed == true  ? (
        <td>
          {dataValue?moment(dataValue).format('DD-MMM-YYYY'):''}
        </td>
      ) : (
        <td onClick={this.handleEditCell}>
          {dataValue?moment(dataValue).format('DD-MMM-YYYY'):''}
        </td>
      );
      }
    }
  }
}
